

import React from 'react'
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import Icon from '@/icons';
import { ViewUserEmail } from "./MyAccount/ViewEmail";
import { ChangeSlug } from "./MyAccount/ChangeSlug";
import { ChangeAvatar } from './MyAccount/ChangeAvatar';
import { ChangeBanner } from './MyAccount/ChangeBanner';
import { ChangeUsername } from './MyAccount/ChangeUsername';
import Tippy from '@tippyjs/react';
import { VerifyEmailDialog } from '../VerifyEmail';
import { ChangeEmail } from './MyAccount/ChangeEmail';
import ChangePassword from './MyAccount/ChangePassword';

export const SettingsMyAccount = ({ user }: { user: any }) => {
    const [email, setEmail] = React.useState(user?.user?.email);
    const [banner, setBanner] = React.useState(user?.user?.banner);
    const [avatar, setAvatar] = React.useState(user?.user?.profilePicture);
    const [slug, setSlug] = React.useState(user?.user?.subdomain);
    const [username, setUsername] = React.useState(user?.user?.username);
    return (
        <div className="flex flex-col items-center w-full focus:outline-none">
            <div className="flex flex-col items-center sm:items-start justify-center w-full sm:justify-start">
                <div className="relative sm:w-1/2 border border-brand-dark rounded-lg">
                    <div className="flex items-center relative bg-brand-dark">
                        <div className="h-36 rounded-t-lg overflow-hidden w-full items-center relative group">
                            <ChangeBanner ChangeBanner={setBanner}>
                                {banner && <img src={banner} draggable="false" className="w-full object-cover" />}
                                <span className="hidden group-hover:flex gap-2 items-center z-10 absolute h-8 w-8 right-4 bottom-4 bg-brand-green text-white hover:bg-brand-profile duration-300 rounded-lg px-2 py-1">
                                    <Icon name="picture" size='16' />
                                </span>
                            </ChangeBanner>
                        </div>

                        <div className="absolute -bottom-6 left-12 transform -translate-x-1/2 rounded-full group">
                            <ChangeAvatar ChangeAvatar={setAvatar}>
                                <div className='relative group'>
                                    <Avatar className="w-20 h-20 rounded-full border-brand-dark border-4 bg-gray-600">
                                        <AvatarImage src={avatar} />
                                        <AvatarFallback>{user?.user?.username?.[0] ?? ''}</AvatarFallback>
                                    </Avatar>
                                    <div className='hidden group-hover:flex absolute -bottom-0 h-full w-full items-center justify-center bg-brand-dark bg-opacity-50 rounded-full'>
                                        <div className="bg-brand-dark text-gray-300 rounded-lg">
                                            <Icon name="picture" size='16' />
                                        </div>
                                    </div>
                                </div>
                            </ChangeAvatar>
                        </div>
                    </div>

                    <div className="flex flex-col items-center pt-12 rounded-b-lg pb-4 px-4 space-y-4 text-center bg-brand-profile">
                        <div className="justify-between flex items-center w-full">
                            <div className="flex flex-col">
                                <h1 className="font-semibold text-lg text-left">
                                    Username
                                </h1>
                                <p className="text-gray-300 text-left">
                                    {username}
                                </p>
                            </div>
                            <div className="flex flex-col">
                                <ChangeUsername setUsername={setUsername}>
                                    <span className="text-gray-300 flex gap-2 items-center hover:text-white bg-brand-dark px-2 py-2 rounded-lg">
                                        <Icon name="pencil" size='16' />
                                        Edit
                                    </span>
                                </ChangeUsername>
                            </div>
                        </div>

                        <div className="justify-between flex items-center w-full">
                            <div className="flex flex-col items-start">
                                <h1 className="font-semibold text-left text-lg">
                                    Slug
                                </h1>
                                <p className="text-gray-300">
                                    {slug}
                                </p>
                            </div>
                            <div className="flex flex-col">
                                <ChangeSlug setSlug={setSlug}>
                                    <span className="text-gray-300 flex gap-2 items-center hover:text-white bg-brand-dark px-2 py-2 rounded-lg">
                                        <Icon name="pencil" size='16' />
                                        Edit
                                    </span>
                                </ChangeSlug>
                            </div>
                        </div>

                        <div className="justify-between flex items-center w-full">
                            <div className="flex flex-col">
                                <h1 className="font-semibold text-left text-lg">
                                    Email
                                </h1>
                                <div className="flex items-center">
                                    <p className="text-gray-300">
                                        {email}
                                    </p>
                                    {!user?.user?.verified && (
                                        <Tippy content="Please verify your email to unlock all features" placement="top" arrow={false}>
                                            <VerifyEmailDialog>
                                                <div className='w-4 h-4 bg-orange-500 rounded-full ml-2 flex items-center justify-center'>
                                                    <Icon name="exclamation" size='10' color='white' />
                                                </div>
                                            </VerifyEmailDialog>
                                        </Tippy>
                                    )}
                                    {email?.includes('*') && (
                                        <ViewUserEmail setEmail={setEmail}>
                                            <span className="text-blue-400 ml-2 cursor-pointer">
                                                View
                                            </span>
                                        </ViewUserEmail>
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <ChangeEmail setEmail={setEmail}>
                                    <span className="text-gray-300 flex gap-2 items-center hover:text-white bg-brand-dark px-2 py-2 rounded-lg">
                                        <Icon name="pencil" size='16' />
                                        Edit
                                    </span>
                                </ChangeEmail>
                            </div>
                        </div>
                    </div>
                </div>


                <h1 className="text-gray-300 text-lg font-semibold mt-4">
                    Password
                </h1>

                <ChangePassword>
                    <button
                        className="bg-brand-green flex gap-2 items-center px-5 py-2 w-full mt-4 rounded-lg text-white font-semibold hover:bg-green-500"
                    >
                        <Icon name="key" size='16' color='white' />
                        Change Password
                    </button>
                </ChangePassword>
            </div>
        </div>
    );
};
